import { Outlet, Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />

      {/* Sticky Mobile Inquiry Button */}
      <Link
        to="/contact"
        className="lg:hidden fixed bottom-6 right-6 z-50 cursor-pointer inline-flex items-center gap-2 px-5 py-3.5 rounded-full bg-primary-500 text-background-50 shadow-lg hover:bg-primary-600 transition-colors font-label text-[13px] tracking-[0.12em] uppercase"
      >
        <i className="ri-chat-1-line" />
        <span>Inquire</span>
      </Link>
    </div>
  );
}